import { Icon } from '@chakra-ui/react';

export const ContentAnalyzerGradient = (props) => (
  <Icon viewBox="0 0 24 24" boxSize="16px" color="icon.g1" {...props}>
    <path
      d="M5 5H15.4127L15.4127 10.7331C15.7728 10.8412 16.1093 11.0025 16.4127 11.2077V5C16.4127 4.44772 15.965 4 15.4127 4H5C4.44772 4 4 4.44772 4 5V14.1925C4 14.7448 4.44771 15.1925 5 15.1925H6.80453C6.99937 15.1925 7.18997 15.2494 7.35291 15.3562L9.65796 16.8679C9.99094 17.0862 10.4217 17.0862 10.7547 16.8679L11.4709 16.3982C11.2624 16.1379 11.0896 15.8487 10.9598 15.5375L10.2063 16.0316L7.90129 14.52C7.57542 14.3063 7.19422 14.1925 6.80453 14.1925H5V5Z"
      fill="url(#paint0_linear_218_883)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.0743 16.9095C15.6139 17.1971 15.0699 17.3633 14.4871 17.3633C12.8302 17.3633 11.4871 16.0201 11.4871 14.3633C11.4871 12.7064 12.8302 11.3633 14.4871 11.3633C16.1439 11.3633 17.4871 12.7064 17.4871 14.3633C17.4871 15.0461 17.2589 15.6756 16.8748 16.1798L19.8398 19.0817C20.0614 19.2986 20.0526 19.6541 19.8204 19.8601C19.6053 20.051 19.2761 20.0431 19.0707 19.8421L16.0743 16.9095ZM16.7366 14.3633C16.7366 15.6059 15.7293 16.6133 14.4866 16.6133C13.244 16.6133 12.2366 15.6059 12.2366 14.3633C12.2366 13.1206 13.244 12.1133 14.4866 12.1133C15.7293 12.1133 16.7366 13.1206 16.7366 14.3633Z"
      fill="url(#paint1_linear_218_883)"
    />
    <path
      d="M11.2216 7.56148C11.2216 7.28051 11.4494 7.05273 11.7304 7.05273H14.3248L14.3242 9.58827C14.3242 9.87391 14.0927 10.1055 13.807 10.1055C13.5214 10.1055 13.2898 9.87391 13.2898 9.58827V8.79189L10.9186 11.124L10.8929 11.0987L9.33132 9.68481L7.12802 11.8521C6.92605 12.0508 6.59858 12.0508 6.3966 11.8521C6.19462 11.6534 6.19462 11.3313 6.3966 11.1326L9.30097 8.2757L10.8894 9.71388L12.5606 8.07023H11.7304C11.4494 8.07023 11.2216 7.84246 11.2216 7.56148Z"
      fill="url(#paint2_linear_218_883)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_218_883"
        x1="4.22763"
        y1="4.00003"
        x2="16.4127"
        y2="4.00003"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#008EF0" />
        <stop offset="0.336458" stopColor="#EC3B64" />
        <stop offset="0.648958" stopColor="#FFC200" />
        <stop offset="1" stopColor="#5CC461" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_218_883"
        x1="11.6432"
        y1="11.3633"
        x2="20.0004"
        y2="11.3633"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#008EF0" />
        <stop offset="0.336458" stopColor="#EC3B64" />
        <stop offset="0.648958" stopColor="#FFC200" />
        <stop offset="1" stopColor="#5CC461" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_218_883"
        x1="6.39328"
        y1="7.05274"
        x2="14.3248"
        y2="7.05274"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#008EF0" />
        <stop offset="0.336458" stopColor="#EC3B64" />
        <stop offset="0.648958" stopColor="#FFC200" />
        <stop offset="1" stopColor="#5CC461" />
      </linearGradient>
    </defs>
  </Icon>
);
